/**
 * Inbox: everything that shapes how conversations get worked - who they route
 * to, the shortcuts agents answer with, and the automation that moves them.
 * One group, the way Intercom keeps its Inbox settings together. Tags and the
 * attribute schemas live in the Data group next door.
 */
export default ({
  t,
  accountScopedRoute,
  hasAdvancedAssignment,
  hasSupportCases,
  isAdmin,
}) => ({
  name: 'Settings Inbox',
  label: t('SIDEBAR.SETTINGS_GROUP_INBOX'),
  icon: 'i-ph-tray',
  defaultFolded: true,
  children: [
    {
      name: 'Settings Teams',
      label: t('SIDEBAR.TEAMS'),
      icon: 'i-ph-users',
      activeOn: [
        'settings_teams_list',
        'settings_teams_new',
        'settings_teams_finish',
        'settings_teams_add_agents',
        'settings_teams_show',
        'settings_teams_edit',
        'settings_teams_edit_members',
        'settings_teams_edit_finish',
      ],
      to: accountScopedRoute('settings_teams_list'),
    },
    ...(hasAdvancedAssignment
      ? [
          {
            name: 'Settings Assignments',
            label: t('SIDEBAR.ASSIGNMENTS'),
            icon: 'i-ph-user-gear',
            // The standalone list routes redirect into the tabbed page, so
            // only the merged index and the create/edit flows can be active.
            activeOn: [
              'assignment_policy_index',
              'agent_assignment_policy_create',
              'agent_assignment_policy_edit',
              'agent_capacity_policy_create',
              'agent_capacity_policy_edit',
            ],
            to: accountScopedRoute('assignment_policy_index'),
          },
        ]
      : []),
    {
      name: 'Settings Macros',
      label: t('SIDEBAR.MACROS'),
      icon: 'i-ph-puzzle-piece',
      to: accountScopedRoute('macros_wrapper'),
    },
    {
      name: 'Settings Canned Responses',
      label: t('SIDEBAR.CANNED_RESPONSES'),
      icon: 'i-ph-chat-centered-text',
      to: accountScopedRoute('canned_list'),
    },
    {
      name: 'Settings Sla',
      label: t('SIDEBAR.SLA'),
      icon: 'i-ph-clock-countdown',
      to: accountScopedRoute('sla_list'),
    },
    ...(hasSupportCases && isAdmin
      ? [
          {
            // The ticket engine's settings: types and their stage rails.
            // Admin-only like the route it points at, and absent while the
            // `support_cases` flag is off - same gates as the API it drives.
            name: 'Settings Tickets',
            label: t('SIDEBAR.TICKETS'),
            icon: 'i-ph-ticket',
            to: accountScopedRoute('settings_ticket_types'),
          },
        ]
      : []),
    {
      // Automation rules. Not the premium Conversation workflow below.
      name: 'Settings Automation',
      label: t('SIDEBAR.AUTOMATION'),
      icon: 'i-ph-git-branch',
      activeOn: ['automation_list'],
      to: accountScopedRoute('workflows_index'),
    },
    {
      name: 'Conversation Workflow',
      label: t('SIDEBAR.CONVERSATION_WORKFLOW'),
      icon: 'i-ph-flow-arrow',
      to: accountScopedRoute('conversation_workflow_index'),
    },
  ],
});
